var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg07Diamond02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 160000 160000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FontID0",
    horizAdvX: 834,
    fontVariant: "normal",
    fillRule: "nonzero",
    fontStyle: "normal",
    fontWeight: 900
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Gordita Ultra"
  }, /*#__PURE__*/React.createElement("fontFaceSrc", null, /*#__PURE__*/React.createElement("fontFaceName", {
    name: "Gordita-Ultra"
  }))), /*#__PURE__*/React.createElement("missingGlyph", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0z"
  })), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 708,
    d: "M44.0001 0l613.017 0 0 188.004 -320.004 0 119.997 91.0033c70.0087,53.0004 120.006,98.0015 150.01,135.003 30.9959,38.0029 46.0022,79 46.0022,124.001 0,74.0039 -27.0007,135.003 -80.0099,184.009 -53.0004,48.9963 -125.002,74.0039 -217.999,74.0039 -73.0028,0 -137.005,-16.9994 -192.008,-50.0062 -55.0024,-32.9979 -92.0043,-82.0031 -111.006,-146.998l189.005 -80.0099c19.0015,47.0032 60.0074,80.0099 105.009,80.0099 48.9963,0 74.996,-30.0037 74.996,-63.0016 0,-36.0098 -23.9977,-66.0046 -100.004,-126.012l-277.005 -222.003 0 -188.004z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_07_Diamond_02.svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ARC_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M92149 155958c41950,-6710 70518,-46157 63809,-88107 -6710,-41950 -46157,-70518 -88107,-63809 -41950,6710 -70518,46157 -63809,88107 5250,32822 30987,58559 63809,63809"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    cx: 80000,
    cy: 80000,
    r: 80000
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_53_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M72308 138462l15384 0c4249,0 7693,3444 7693,7692 0,4248 -3444,7692 -7693,7692l-15384 0c-4249,0 -7693,-3444 -7693,-7692 0,-4248 3444,-7692 7693,-7692z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_52_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "65892,137505 62730,133153 34786,142232 34786,112850 6842,103771 24112,80000 6842,56229 34786,47150 34786,17768 62730,26847 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_51_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "68626,136034 63905,129535 37863,137997 37863,110615 11820,102153 27915,80000 11820,57847 37863,49385 37863,22003 63905,30465 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_50_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M68626 136034c1180,-430 2426,-649 3682,-649"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_49_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "63905,30465 80000,8312 96095,30465 122137,22003 122137,49385 148180,57847 132085,80000 148180,102153 122137,110615 122137,137997 96095,129535 91374,136034 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_48_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "62730,26847 80000,3077 97270,26847 125214,17768 125214,47150 153158,56229 135888,80000 153158,103771 125214,112850 125214,142232 97270,133153 94108,137505 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_47_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M72308 135385l15384 0c1256,0 2502,219 3682,649"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_46_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M67851 155958c-1662,-756 -3105,-1922 -4193,-3388 -3543,-4777 -2543,-11522 2234,-15065"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_45_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M94108 137505c1467,1087 2633,2530 3388,4192 2462,5415 67,11799 -5347,14261"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_44_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "52021,48848 42694,65002 61347,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_43_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "52021,50387 44027,64233 60015,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_42_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61347,65002 70674,48848 52021,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_41_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "61347,63463 69341,49617 53353,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_40_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "70674,48848 61347,65002 80000,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_39_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "70674,50387 62679,64233 78668,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_38_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80000,65002 89326,48848 70674,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_37_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80000,63463 87994,49617 72006,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_36_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "89326,48848 80000,65002 98653,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_35_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "89326,50387 81332,64233 97321,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_34_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "98653,65002 107979,48848 89326,48848 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "98653,63463 106647,49617 90659,49617 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_32_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "107979,48848 98653,65002 117306,65002 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_31_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "107979,50387 99985,64233 115973,64233 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_9_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 42694,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_8_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 61347,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_7_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 98653,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_6_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 117306,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE_5_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 80000,
    y1: 118462,
    x2: 80000,
    y2: 65002
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_30_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "77433,113438 44169,65771 60801,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_29_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "79231,65771 79231,113922 62430,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_28_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "82567,113438 115831,65771 99199,65771 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLYLINE_27_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#010202",
    strokeWidth: 221,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    points: "80769,65771 80769,113922 97570,65771 "
  })))), /*#__PURE__*/React.createElement("text", {
    x: 75327,
    y: 150907,
    fill: "black",
    fontWeight: 900,
    fontSize: "13333px",
    fontFamily: "Gordita Ultra"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    fill: "#1B0921",
    d: "M70674 48848l18652 0 18653 0 9327 16154 -37306 53460 -37306 -53460 9327 -16154 18653 0zm1634 86537l15384 0c1256,0 2502,219 3682,649l4721 -6499 26042 8462 0 -27382 26043 -8462 -16095 -22153 16095 -22153 -26043 -8462 0 -27382 -26042 8462 -16095 -22153 -16095 22153 -26042 -8462 0 27382 -26043 8462 16095 22153 -16095 22153 26043 8462 0 27382 26042 -8462 4721 6499c1180,-430 2426,-649 3682,-649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B0921",
    d: "M95385 146154c0,-4248 -3444,-7692 -7693,-7692l-15384 0c-4249,0 -7693,3444 -7693,7692 0,4248 3444,7692 7693,7692l15384 0c4249,0 7693,-3444 7693,-7692zm-11298 2246l0 2507 -8174 0 0 -2507 3694 -2960c1013,-800 1333,-1200 1333,-1680 0,-440 -347,-840 -1000,-840 -600,0 -1147,440 -1400,1067l-2520 -1067c253,-867 747,-1520 1480,-1960 733,-440 1587,-667 2560,-667 1240,0 2200,334 2907,987 706,653 1066,1467 1066,2453 0,600 -200,1147 -613,1654 -400,493 -1067,1093 -2000,1800l-1600 1213 4267 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    stroke: "#7D6612",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M84087 148400l-4267 0 1600 -1213c933,-707 1600,-1307 2000,-1800 413,-507 613,-1054 613,-1654 0,-986 -360,-1800 -1066,-2453 -707,-653 -1667,-987 -2907,-987 -973,0 -1827,227 -2560,667 -733,440 -1227,1093 -1480,1960l2520 1067c253,-627 800,-1067 1400,-1067 653,0 1000,400 1000,840 0,480 -320,880 -1333,1680l-3694 2960 0 2507 8174 0 0 -2507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M52021 50387l7994 13846 -15988 0 7994 -13846zm-9327 14615l18653 0 -9326 -16154 -9327 16154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M52021 48848l9326 16154 9327 -16154 -18653 0zm9326 14615l-7994 -13846 15988 0 -7994 13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M70674 48848l-9327 16154 18653 0 -9326 -16154zm-7995 15385l7995 -13846 7994 13846 -15989 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M70674 48848l9326 16154 9326 -16154 -18652 0zm1332 769l15988 0 -7994 13846 -7994 -13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M89326 48848l-9326 16154 18653 0 -9327 -16154zm-7994 15385l7994 -13846 7995 13846 -15989 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M89326 48848l9327 16154 9326 -16154 -18653 0zm1333 769l15988 0 -7994 13846 -7994 -13846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M107979 48848l-9326 16154 18653 0 -9327 -16154zm-7994 15385l7994 -13846 7994 13846 -15988 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M117306 65002l-18653 0 -18653 53460 37306 -53460zm-34739 48436l16632 -47667 16632 0 -33264 47667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 118462l18653 -53460 -18653 0 0 53460zm769 -52691l16801 0 -16801 48151 0 -48151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 118462l0 -53460 -18653 0 18653 53460zm-769 -52691l0 48151 -16801 -48151 16801 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082187",
    stroke: "#0C709E",
    strokeWidth: 400,
    strokeMiterlimit: 22.9256,
    d: "M80000 118462l-18653 -53460 -18653 0 37306 53460zm-19199 -52691l16632 47667 -33264 -47667 16632 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "77433,113438 60801,65771 44169,65771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "44027,64233 60015,64233 52021,50387 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "53353,49617 61347,63463 69341,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "79231,65771 62430,65771 79231,113922 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "80769,65771 80769,113922 97570,65771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "80000,63463 87994,49617 72006,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "89326,50387 81332,64233 97321,64233 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "90659,49617 98653,63463 106647,49617 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "107979,50387 99985,64233 115973,64233 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "115831,65771 99199,65771 82567,113438 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M62730 26847l17270 -23770 17270 23770 27944 -9079c-15958,-11594 -36346,-17087 -57363,-13726 -41950,6710 -70518,46157 -63809,88107 5250,32822 30987,58559 63809,63809 -1662,-756 -3105,-1922 -4193,-3388 -3543,-4777 -2543,-11522 2234,-15065l-3162 -4352 -27944 9079 0 -29382 -27944 -9079 17270 -23771 -17270 -23771 27944 -9079 0 -29382 27944 9079z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8933D4",
    d: "M125214 17768l0 29382 27944 9079 -17270 23771 17270 23771 -27944 9079 0 29382 -27944 -9079 -3162 4352c1467,1087 2633,2530 3388,4192 2462,5415 67,11799 -5347,14261 41950,-6710 70518,-46157 63809,-88107 -3348,-20934 -14849,-38535 -30744,-50083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#270545",
    stroke: "#0B0F8A",
    strokeWidth: 1200,
    strokeMiterlimit: 22.9256,
    d: "M125214 17768c15895,11548 27396,29149 30744,50083 6709,41950 -21859,81397 -63809,88107 5414,-2462 7809,-8846 5347,-14261 -755,-1662 -1921,-3105 -3388,-4192l3162 -4352 27944 9079 0 -29382 27944 -9079 -17270 -23771 17270 -23771 -27944 -9079 0 -29382zm-121172 74381c-6709,-41950 21859,-81397 63809,-88107 21017,-3361 41405,2132 57363,13726l-27944 9079 -17270 -23770 -17270 23770 -27944 -9079 0 29382 -27944 9079 17270 23771 -17270 23771 27944 9079 0 29382 27944 -9079 3162 4352c-4777,3543 -5777,10288 -2234,15065 1088,1466 2531,2632 4193,3388 -32822,-5250 -58559,-30987 -63809,-63809zm33821 -42764l0 -27382 26042 8462 16095 -22153 16095 22153 26042 -8462 0 27382 26043 8462 -16095 22153 16095 22153 -26043 8462 0 27382 -26042 -8462 -4721 6499c-1180,-430 -2426,-649 -3682,-649l-15384 0c-1256,0 -2502,219 -3682,649l-4721 -6499 -26042 8462 0 -27382 -26043 -8462 16095 -22153 -16095 -22153 26043 -8462zm34445 89077l15384 0c4249,0 7693,3444 7693,7692 0,4248 -3444,7692 -7693,7692l-15384 0c-4249,0 -7693,-3444 -7693,-7692 0,-4248 3444,-7692 7693,-7692zm87692 -58462c0,-44183 -35817,-80000 -80000,-80000 -44183,0 -80000,35817 -80000,80000 0,44183 35817,80000 80000,80000 44183,0 80000,-35817 80000,-80000z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Diamond02);
export default __webpack_public_path__ + "static/media/07_Diamond_02.1e057c5c5bb3e0e9df864ab3c58c5dde.svg";
export { ForwardRef as ReactComponent };